import { render } from "./FABEditorCmp.vue?vue&type=template&id=9ea8debe&scoped=true"
import script from "./FABEditorCmp.vue?vue&type=script&lang=js"
export * from "./FABEditorCmp.vue?vue&type=script&lang=js"

import "./FABEditorCmp.vue?vue&type=style&index=0&id=9ea8debe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ea8debe"]])

export default __exports__